import CreateOrderRepository from '../../domain/repositories/CreateOrderRepository';
import CreateOrderDataStore from '../datastores/CreateOrderDataStore';
import CreateOrderDataStoreFactory from '../factories/CreateOrderRequestDataStoreFactory';

export default class CreateOrderDataRepository
  implements CreateOrderRepository
{
  register(items: string[], amount: number) {
    const createOrderRequestDataStore: CreateOrderDataStore =
      CreateOrderDataStoreFactory.create();
    return createOrderRequestDataStore.register(items, amount);
  }
}
